import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/visualisations/Pie/settings/DataTab';
import { ViewTab } from 'modules/visualisations/Pie/settings/ViewTab';

export const PieMainSettings = () => {
  return <SettingsLayout DataComponent={DataTab} ViewComponent={ViewTab} />;
};
